import { render, staticRenderFns } from "./NewPriceList.vue?vue&type=template&id=33321fdf&"
import script from "./NewPriceList.vue?vue&type=script&lang=js&"
export * from "./NewPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports